<template>
  <div>
    <MasterLayout>
      <div class="fuelbalance_first_row">
        <div
          class="card_container"
          style="border-radius: 17px"
          :style="{
            backgroundImage: `url(${cardBackgroundUrl})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right',
            backgroundSize: ' 136px',
          }"
        >
          <div class="card__header___text">
            <div>
              <h3 class="our_branches__header text-center">
                {{ $t("text.productSummary.total") }}
              </h3>
              <div class="dealer__icon__wrapper mt-3">
                <div class="dealer__icon__div text-center">
                  <div>
                    <img src="@/assets/img/wallet.svg" width="35px" />
                  </div>
                </div>
              </div>
              <div class="text-center mt-3">
                <h3>
                  {{ branch ? branch.currencyCode : "" }} {{ totalAmountSpent }}
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div
          class="fuelbalance_first_row_right_section mr-3 co_dealer"
          style="border-radius: 22px"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31 , 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="our__branches__banner">
            <div class="row align-items-center section__row">
              <div class="col-md-6 text-center section___column_1">
                <h3 class="our__branches__banner__title">
                  {{ $t("text.endOfDayReport.retainershipSales") }} ({{
                    rsCount
                  }})
                </h3>
              </div>
              <div class="col-md-6 drop_down_input_group">
                <div class="drop_down_section mt-2 mr-2">
                  <div class="drop_down_div align-items-center">
                    <vue-ctk-date-time-picker
                      v-model="dateRange"
                      :max-date="maxDate"
                      :range="true"
                      :autoClose="true"
                      :locale="this.$root.$i18n.locale"
                      :custom-shortcuts="customShortcuts"
                      :color="$store.getters.getDatePickerColor"
                      format="DDMMYYYY"
                      formatted="DD/MM/YYYY"
                      :label="$t('text.calendar.dateRange')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="section__row mt-3">
        <div class="">
          <div class="">
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :excelQueryCellInfo="excelQueryCellInfo"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="40px" field="index" headerText="#"></e-column>
                <e-column
                  field="date"
                  width="200"
                  :format="formatOptions"
                  type="date"
                  :headerText="$t('text.bWallet.date')"
                ></e-column>
                <e-column
                  field="productName"
                  width="100"
                  :headerText="$t('text.bWallet.product')"
                ></e-column>
                <e-column
                  field="pumpName"
                  width="150"
                  :headerText="$t('text.pumpsCalibration.pumpName')"
                ></e-column>
                <e-column
                  field="priceSold"
                  width="150"
                  :headerText="$t('text.bSales.priceSold')"
                ></e-column>
                <e-column
                  field="amount"
                  width="150"
                  :headerText="$t('text.form.amount')"
                ></e-column>
                <e-column
                  field="volSold"
                  width="150"
                  :headerText="$t('text.sales.volSold')"
                ></e-column>
                <e-column
                  width="180"
                  field="salesType"
                  :headerText="$t('text.staff.staffName')"
                ></e-column>
                <e-column
                  width="180"
                  field="staffName"
                  headerText="Staff"
                ></e-column>
                <e-column
                  width="180"
                  field="voucherCardNumber"
                  :headerText="$t('text.omit.voucherCardNo')"
                ></e-column>
                <e-column
                  width="180"
                  field="uniqueId"
                  :headerText="$t('text.omit.uniqueID')"
                ></e-column>
                <!-- <e-column
                  format="N2"
                  field="amount"
                  width="200"
                  :headerText="`${$t('text.bWallet.amountSpent')} (${
                    branch ? branch.currency : ''
                  })`"
                ></e-column> -->
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import backgroundUrl from "@/assets/img/BecomeDealer.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "OurBranches",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      formatOptions: { type: "date", format: "dd/MM/yyyy hh:mm a" },
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      startDate: this.$moment().format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      branch: {},
      branchId: null,
      backgroundUrl,
      totalAmountSpent: 0,
      cardBackgroundUrl,
      showLoader: false,
      // walletBalance: 0,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Print", "Search"],
      search: { operator: "contains", ignoreCase: true },
      userDetails: JSON.parse(localStorage.getItem("userDetails")),

      rsCount: 0,
    };
  },
  created() {
    if (localStorage.getItem("userDetails") === "null") {
      this.$router.push({ path: "/" });
    } else if (configObject.authConfig() === null) {
      window.location.reload();
    }
    // console.log(this.userDetails.roles.includes("viewESales"));
    this.showLoader = true;
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Retail Outlet Retianership:: ${branch.name} Retail Outlet`;
    });

    if (this.$route.query.startDate && this.$route.query.endDate) {
      this.dateRange.start = this.$moment(this.$route.query.startDate).format(
        "D-M-YYYY"
      );
      this.dateRange.end = this.$moment(this.$route.query.endDate).format(
        "D-M-YYYY"
      );
    } else {
      this.dateRange.start = this.pluginStartDate;
      this.dateRange.end = this.pluginEndDate;

      this.$router.replace({
        name: this.$route.name,
        query: {
          branchId: this.$route.query.branchId
            ? this.$route.query.branchId
            : this.branch.id,
          groupId: this.$route.query.groupId,
          regionId: this.$route.query.regionId,
          dealerId: this.$route.query.dealerId,
          companyId: this.$route.query.companyId,
          startDate: this.$moment(this.pluginStartDate, "DD-MM-YYYY").format(
            "MMMM D, YYYY"
          ),
          endDate: this.$moment(this.pluginEndDate, "DD-MM-YYYY").format(
            "MMMM D, YYYY"
          ),
        },
      });
    }

    // this.dateRange.start = this.pluginStartDate;
    // this.dateRange.end = this.pluginEndDate;

    document.title = `Retail Outlet Wallet:: Epump Retail Outlet`;
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  watch: {
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        this.branchId = this.branch.id;
        if (this.branchId !== null) {
          this.getRetainershipSales();
          $(".e-input").keyup(function (e) {
            searchFun(e);
          });
          function searchFun(event) {
            var grid =
              document.getElementsByClassName("e-grid")[0].ej2_instances[0];
            var value = event.target.value;
            grid.search(value);
          }
        }
      }
    },
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.$router.replace({
          name: this.$route.name,
          query: {
            branchId: this.$route.query.branchId
              ? this.$route.query.branchId
              : this.branch.id,
            groupId: this.$route.query.groupId,
            regionId: this.$route.query.regionId,
            dealerId: this.$route.query.dealerId,
            companyId: this.$route.query.companyId,
            startDate: this.startDate,
            endDate: this.endDate,
          },
        });

        this.getRetainershipSales();
      }
    },
  },
  beforeDestroy() {},
  mounted() {},
  methods: {
    excelQueryCellInfo(args) {
      if (args.column.field == "date") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY");
      }
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
        case "Print":
          this.$refs.dataGrid.print();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    getRetainershipSales() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/RetainershipSales/${this.branchId}?startDate=${this.$route.query.startDate}&endDate=${this.$route.query.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;

          let index = 0;

          response.data.forEach((element) => {
            this.totalAmountSpent = response.data
              .reduce((a, b) => {
                return a + b.amount;
              }, 0)
              .toLocaleString();
            element.index = ++index;
            element.date = this.$moment(element.date).format("lll");
            if (element.salesType == "") {
              element.salesType = this.$t("text.general.na");
            }
            if (element.productName == null) {
              element.productName = this.$t("text.general.na");
            } else {
              element.productName = element.productName.toUpperCase();
            }
          });

          this.rsCount = response.data.length;

          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {});
    },
    decimalThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
